/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, lazy } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { AuthPage } from '../modules/auth'
import { App } from '../App'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
// const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const SingleSignOn = lazy(() => import('../appWebview/SingleSignOn')) //for mobile app webview
  const SingleSignOnPage = lazy(() => import('../pages/SingleSignOnPage')) //for iproforma
  const OrderSummaryPage = lazy(() => import('../pages/OrderSummaryPage'))
  const agentSlice = useSelector((state: RootState) => state.agent)

  return (
    <BrowserRouter basename={'/'}>
      <Routes>
        <Route element={<App />}>
          {agentSlice?._id ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={agentSlice.newTnc === true ? '/tnc' : '/dashboard'} />} />
            </>
          ) : (
            <>
              <Route path='/' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/' />} />
            </>
          )}
          <Route path='/signon/:key' element={<SingleSignOnPage />} />
          <Route path='webview/singleSignOn/:target/:key' element={<SingleSignOn />} />
          <Route path='/ordersummary/:refNo' element={<OrderSummaryPage />} />
          <Route path='/error/*' element={<ErrorsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
